import { ArticleMode } from '../../types/articleGeneration';

const THIN_NOTES_CHARS = 200;

/** Little to write from: the article will be qualitative; warn before the run. */
export const isThinEvidence = (inputs: {
  sourceNotes: string;
  quotes: string;
  sourceData: string;
}): boolean =>
  inputs.sourceNotes.trim().length < THIN_NOTES_CHARS &&
  inputs.quotes.trim() === '' &&
  inputs.sourceData.trim() === '';

/** Rough wall-clock estimate in minutes, shown before the run. */
export const estimateMinutes = (mode: ArticleMode, headingCount: number): { min: number; max: number } => {
  if (mode === 'headings') return { min: 1, max: 2 };
  if (mode === 'headings_briefs') return { min: 2, max: 3 };
  // plan ≈ 2 min, writing ≈ 0.75 min per section (+ lead), critique ≈ 3–6 min
  const writing = (headingCount + 1) * 0.75;
  return { min: Math.round(2 + writing + 3), max: Math.round(2 + writing * 1.5 + 6) };
};
